/**
 * Cart Offcanvas Presenter
 */
class CartOffcanvasPresenter {

	constructor(sectionId) {

		this.view = new CartOffcanvasView(this, sectionId);

		/*
		 * Listeners
		 */

		$(document).on(Model.CART_RETRIEVED, $.proxy(function(_event, cart) {
			// set/update the cart in the view
			this.view.setCart(cart);
			// check if we need to show the cart, and if we do make sure we reset the hash
			if (location.hash == "#mon-cart-offcanvas-show") {
			 	this.view.showCart();
			 	location.hash = "";
			}
		}, this));

		$(document).on(Model.CART_ITEM_QUANTITY_UPDATED, $.proxy(function(_event, cart, delta) {
			// update the cart
			this.view.updateCart(cart, delta);
		}, this));

		$(document).on(Model.CART_DELETED, $.proxy(function(_event, cart) {
			// the cart object will have no items, so calling to the view will clear the cart
			this.view.setCart(cart);
		}, this));

		/*
		 * Initialisation
		 */

		$(document).trigger(Model.RETRIEVE_CART);

	}

	/*
	 * Actions
	 */

	updateItemQuantity(variantId, quantity) {
		const delta = { "id": variantId, "quantity": quantity };
		$(document).trigger(Model.UPDATE_CART_ITEM_QUANTITY, [delta]);
	}

	deleteItems() {
		$(document).trigger(Model.DELETE_CART);
	}

	/*
	 * Getters and Setters
	 */

}